import { dwmRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _directiveDependencies = [];
const _controllerDependencies = ['$scope', '$state', '$rootScope'];

class DwmAlertsController {

    constructor($scope, $state, $rootScope) {

        $scope.alertsLoading = true;

        const buildAlerts = () => {

            if ($scope.aiaSubscriptionCancelled || $scope.dwmLiteSubscriptionCancelled) {

                $scope.alertsLoading = false;

            }

        };

        buildAlerts();

        const dwmStatusListener = $rootScope.$on('dwm_status_fetch_completed', () => {

            buildAlerts();

        });


        const paginate = (arr, size) => arr.reduce((acc, val, i) => {

            const idx = Math.floor(i / size);
            const page = acc[idx] || (acc[idx] = []);
            page.push(val);

            return acc;

        }, []);

        const onDwmDataNext = () => {

            const alerts = dwmRepository.getAll('alerts') || {};
            $scope.unreadAlerts = 0;

            if (alerts.alertList) {

                $scope.activePage = $rootScope.alertsActivePage;

                alerts.alertList.forEach((alert) => {

                    alert.formattedDate = moment(alert.createdAt).format('L');
                    if (alert.isRead === false && alert.bucket === 'inbox') {

                        $scope.unreadAlerts += 1;

                    }

                });

                $scope.alerts = paginate(alerts.alertList, 10);
                $scope.alertsLoading = false;

                if ($rootScope.alertsActivePage < $scope.alerts.length) {

                    $scope.nextArrowEnabled = true;

                }

                if ($rootScope.alertsActivePage === 1) {

                    $scope.prevArrowEnabled = false;

                }

            }


        };

        const dwmRepositoryObservable = dwmRepository.getObservable();
        dwmRepositoryObservable
            .subscribe(
                data => onDwmDataNext(data),
                () => { },
                () => { },
            );

        $scope.nextPage = () => {

            $scope.activePage += 1;
            $rootScope.alertsActivePage = $scope.activePage;
            $scope.nextArrowEnabled = !!($scope.activePage < $scope.alerts.length);
            $scope.prevArrowEnabled = !!($scope.activePage !== 1);

        };

        $scope.prevPage = () => {

            $scope.activePage -= 1;
            $rootScope.alertsActivePage = $scope.activePage;
            $scope.nextArrowEnabled = !!($scope.activePage < $scope.alerts.length);
            $scope.prevArrowEnabled = !!($scope.activePage !== 1);

        };

        $scope.openAlertModal = (alertId) => {

            Mixpanel.send('ConnectWeb AIA Notification Click');

            $state.go('root.dashboard.dwm.ltb', {
                ltb: 'notifications',
                resourceId: alertId,
            });

        };

        $scope.$on('$destroy', () => {

            dwmStatusListener();

        });

    }

}


class CryptoFaqDirective {

    constructor() {

        this.template = require('./dwm-alerts.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push(($scope, $state, $rootScope) =>
            new DwmAlertsController($scope, $state, $rootScope));
        this.controller = _controllerDependencies;
        this.controllerAs = 'DwmAlertsCtrl';

    }

}

_directiveDependencies.push(() => new CryptoFaqDirective());


angular.module('directives')
    .directive('dwmAlerts', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/dwm-alerts/dwm-alerts.js